import $ from "jquery";
import Swiper from "swiper";
import { Navigation, Pagination } from 'swiper/modules';
import 'swiper/swiper-bundle.css';

Swiper.use([Navigation, Pagination]);

document.addEventListener('DOMContentLoaded', () => {
  const milestones = document.querySelectorAll('.milestone');

  milestones.forEach((milestone) => {
    const toggle = milestone.querySelector('.timeline__accordion-toggle');
    const panel = milestone.querySelector('.timeline__accordion-panel');
    if (!toggle || !panel) {
      return;
    }

    const closeBtn = milestone.querySelector('.timeline__accordion-close');
    const swiperSelector = milestone.querySelector('.timeline__articles-slider');
    const label = toggle.querySelector('.timeline__accordion-label');

    let swiperInstance = null;

    function openPanel() {
      toggle.setAttribute('aria-expanded', 'true');
      toggle.classList.add('active');
      panel.classList.add('open');

      if (label) {
        label.textContent = 'Close Key Events';
      }

      if (!swiperInstance && swiperSelector) {
        swiperInstance = new Swiper(swiperSelector, {
          slidesPerView: 1,
          spaceBetween: 16,
          loop: false,
          observer: true,
          observeParents: true,
          navigation: {
            nextEl: milestone.querySelector('.swiper-button-next'),
            prevEl: milestone.querySelector('.swiper-button-prev')
          },
          breakpoints: {
            768: { slidesPerView: 2 },
            1024: { slidesPerView: 3 }
          }
        });
      }
    }

    function closePanel() {
      toggle.setAttribute('aria-expanded', 'false');
      toggle.classList.remove('active');
      panel.classList.remove('open');

      if (label) {
        label.textContent = 'View Key Events';
      }
    }

    toggle.addEventListener('click', () => {
      const isExpanded = toggle.getAttribute('aria-expanded') === 'true';
      isExpanded ? closePanel() : openPanel();
    });

    if (closeBtn) {
      closeBtn.addEventListener('click', (e) => {
        e.preventDefault();
        closePanel();
      });
    }
  });
});
